/*

First section controls the appearance of the slide down product bar / add to cart
section that appears when you scroll a certain distance down the product page.

 */
const productBar    = document.getElementById('product-bar');
const stickyHeader  = document.getElementById('sticky-header');

function showProductBar() {
    if (stickyHeader) productBar.style.top = (stickyHeader.offsetHeight - 1) + 'px';
    productBar.classList.add('show');
}
function hideProductBar() {
    productBar.classList.remove('show');
}

// Show bar when BOTH the title and ATC button have left the viewport.
// On mobile the ATC button is below the image so the title scrolling off
// triggers first, giving a much earlier appearance.
var mainAtcButtons = document.querySelector('.summary .product-form__buttons');
var productTitle   = document.querySelector('.product-title h1');
var atcVisible   = true;
var titleVisible = true;

function updateBar() {
    (!atcVisible && !titleVisible) ? showProductBar() : hideProductBar();
}

var barObserver = new IntersectionObserver(function(entries) {
    entries.forEach(function(e) {
        if (e.target === mainAtcButtons) atcVisible   = e.isIntersecting;
        if (e.target === productTitle)   titleVisible = e.isIntersecting;
    });
    updateBar();
});

if (mainAtcButtons) barObserver.observe(mainAtcButtons);
if (productTitle)   barObserver.observe(productTitle);

/* ----------------------- end of product bar controller ------------------------------ */


/*

The left and right arrow for the product image thumbnails scroller

 */

const rightArrow = document.querySelector(".images .carousel-next");
const leftArrow = document.querySelector(".images .carousel-prev");
const scrollWindow = document.querySelector('.images .scroll-window');

rightArrow.addEventListener('click', scrollWindowRight);
leftArrow.addEventListener('click', scrollWindowLeft);

function scrollWindowRight()
{
    scrollWindow.scrollBy({ left: 200, behavior: "smooth" });
}

function scrollWindowLeft()
{
    scrollWindow.scrollBy({ left: -200, behavior: "smooth" });
}

/* ----------------------- end of product thumbnails scroller ------------------------------ */


/*

Open or close the product availability modal window

 */

const availability = document.getElementById('availability');
availability.addEventListener('click', toggleAvailabilityModal);

const availabilityOverlay = document.getElementById('availability-overlay');
const availabilityOverlayClose = document.getElementById('availability-close');


availabilityOverlay.addEventListener('click', ( e ) => {
    e.preventDefault();
    if ( e.target.closest('#availability-info') ) {
        /* Don't close, that's a click in our info box */
        return false;
    } else {
        /* Do close, that's a click on the overlay itself */
        toggleAvailabilityModal();
    }
});
availabilityOverlayClose.addEventListener('click', ( e ) => {
    e.preventDefault();
    toggleAvailabilityModal();
})


function toggleAvailabilityModal()
{
    /* toggleOverlay defined in the header.js file */
    toggleOverlay();
    toggleAvailability();
    if (typeof fetchStockAvailability === 'function') {
        fetchStockAvailability();
    }
}


function toggleAvailability()
{
    availabilityOverlay.classList.toggle('show');
}

/* ----------------------- end of product availability modal ------------------------------ */


/* ----------------------- image hover zoom ------------------------------ */

const mainImage = document.getElementById('main-image');
const mainImageContainer = document.querySelector('.images .main-image');

mainImageContainer.addEventListener('mousemove', function(e) {
    const rect = mainImageContainer.getBoundingClientRect();
    // image sits in the centre 80% of the container (10% padding each side)
    const x = Math.max(0, Math.min(100, ((e.clientX - rect.left - rect.width * 0.1) / (rect.width * 0.8)) * 100));
    const y = Math.max(0, Math.min(100, ((e.clientY - rect.top) / rect.height) * 100));
    mainImage.style.transition = 'none';
    mainImage.style.transformOrigin = x + '% ' + y + '%';
    mainImage.style.transform = 'scale(2.5)';
});

mainImageContainer.addEventListener('mouseleave', function() {
    mainImage.style.transition = 'transform 0.2s ease';
    mainImage.style.transform = '';
});

/* ----------------------- lightbox image viewer ------------------------------ */

const imageOverlay = document.getElementById('image-overlay');
const overlayImage = document.getElementById('overlay-main-image');
const overlayClose = document.getElementById('overlay-close');
const overlayPrev = document.getElementById('overlay-prev');
const overlayNext = document.getElementById('overlay-next');

// Build ordered image URL list from the main carousel thumbnails
const thumbnails = document.querySelectorAll('.images .scroll-window .thumbnail');
const imageURLs = Array.from(thumbnails).map(function(t) {
    return t.dataset.full || t.getAttribute('src').replace(/\?.*$/, '');
});

let currentImageIndex = 0;

function openLightbox(index) {
    currentImageIndex = Math.max(0, Math.min(imageURLs.length - 1, index));
    overlayImage.setAttribute('src', imageURLs[currentImageIndex]);
    overlayPrev.style.display = imageURLs.length <= 1 ? 'none' : '';
    overlayNext.style.display = imageURLs.length <= 1 ? 'none' : '';
    toggleOverlay();
    imageOverlay.classList.add('show');
}

// Lightbox zoom — click through 3 levels then reset
var lbStep = 0;
var lbStepScales = null;
var lbOriginX = 50;
var lbOriginY = 50;

function lbResetZoom() {
    lbStep = 0;
    lbStepScales = null;
    lbOriginX = 50;
    lbOriginY = 50;
    overlayImage.style.transform = '';
    overlayImage.style.transformOrigin = '';
}

overlayImage.addEventListener('click', function(e) {
    e.stopPropagation();

    // Build 3 evenly-spaced steps up to natural resolution on first click
    if (!lbStepScales) {
        var dispW = overlayImage.clientWidth || 400;
        var naturalMax = overlayImage.naturalWidth > 0 ? overlayImage.naturalWidth / dispW : 4;
        naturalMax = Math.max(2, naturalMax);
        var inc = (naturalMax - 1) / 3;
        lbStepScales = [1 + inc, 1 + inc * 2, naturalMax];
    }

    // Capture the click position as anchor on the first zoom step only
    if (lbStep === 0) {
        var rect = overlayImage.getBoundingClientRect();
        lbOriginX = ((e.clientX - rect.left) / rect.width) * 100;
        lbOriginY = ((e.clientY - rect.top) / rect.height) * 100;
    }

    lbStep = (lbStep + 1) % (lbStepScales.length + 1);

    if (lbStep === 0) {
        lbResetZoom();
    } else {
        overlayImage.style.transformOrigin = lbOriginX + '% ' + lbOriginY + '%';
        overlayImage.style.transform = 'scale(' + lbStepScales[lbStep - 1] + ')';
    }
});

function closeLightbox() {
    lbResetZoom();
    imageOverlay.classList.remove('show');
    toggleOverlay();
}

function showLightboxImage(index) {
    lbResetZoom();
    currentImageIndex = ((index % imageURLs.length) + imageURLs.length) % imageURLs.length;
    overlayImage.setAttribute('src', imageURLs[currentImageIndex]);
}

function setActiveThumbnail(idx) {
    thumbnails.forEach(function(t) { t.classList.remove('active'); });
    if (thumbnails[idx]) thumbnails[idx].classList.add('active');
}

// Thumbnail click: fade main image, swap src, mark active
thumbnails.forEach(function(thumb, i) {
    thumb.addEventListener('click', function() {
        const fullSrc = thumb.dataset.full || thumb.getAttribute('src').replace(/\?.*$/, '');
        mainImage.style.transition = 'opacity 0.15s ease';
        mainImage.style.opacity = '0';
        setTimeout(function() {
            mainImage.setAttribute('src', fullSrc);
            mainImage.removeAttribute('srcset');
            mainImage.removeAttribute('sizes');
            mainImage.style.opacity = '1';
        }, 150);
        setActiveThumbnail(i);
        currentImageIndex = i;
    });
});

// Main image click: reset zoom and open lightbox
mainImage.addEventListener('click', function() {
    mainImage.style.transition = 'none';
    mainImage.style.transform = '';
    openLightbox(currentImageIndex);
});

overlayClose.addEventListener('click', function(e) { e.stopPropagation(); closeLightbox(); });
overlayPrev.addEventListener('click', function(e) { e.stopPropagation(); showLightboxImage(currentImageIndex - 1); });
overlayNext.addEventListener('click', function(e) { e.stopPropagation(); showLightboxImage(currentImageIndex + 1); });

// Click on dark backdrop closes lightbox
imageOverlay.addEventListener('click', function(e) {
    if (e.target === imageOverlay) closeLightbox();
});

// Keyboard navigation
document.addEventListener('keydown', function(e) {
    if (!imageOverlay.classList.contains('show')) return;
    if (e.key === 'ArrowLeft')  showLightboxImage(currentImageIndex - 1);
    if (e.key === 'ArrowRight') showLightboxImage(currentImageIndex + 1);
    if (e.key === 'Escape')     closeLightbox();
});

/* ----------------------- end of image viewer ------------------------------ */

function fitProductTitle() {
    var h1 = document.querySelector('.product-title h1');
    if (!h1) return;

    // Reset to CSS-defined size and allow natural wrapping
    h1.style.fontSize = '';
    h1.style.whiteSpace = 'normal';

    var cs      = window.getComputedStyle(h1);
    var lineH   = parseFloat(cs.lineHeight);
    var maxH    = lineH * 2 + 4; // 2 lines + small tolerance

    if (h1.scrollHeight <= maxH) return; // fits in 2 lines, nothing to do

    // Binary-search for the largest font-size that still fits in 2 lines
    var lo = 14, hi = parseFloat(cs.fontSize);
    while (hi - lo > 0.5) {
        var mid = (lo + hi) / 2;
        h1.style.fontSize = mid + 'px';
        if (h1.scrollHeight <= maxH) { lo = mid; } else { hi = mid; }
    }
    h1.style.fontSize = Math.floor(lo) + 'px';
}

var titleResizeTimer;
window.addEventListener('resize', function() {
    clearTimeout(titleResizeTimer);
    titleResizeTimer = setTimeout(fitProductTitle, 100);
});

addEventListener("load", function() {
    const stars = document.getElementById('product-star-rating');
    stars.classList.add('visible');

    fitProductTitle();
});

/* ---- Stock tooltip tap/click toggle ---- */
document.querySelectorAll('.stock-status').forEach(function(el) {
    el.addEventListener('click', function(e) {
        e.stopPropagation();
        var isOpen = el.classList.contains('tooltip-open');
        document.querySelectorAll('.stock-status.tooltip-open').forEach(function(o) { o.classList.remove('tooltip-open'); });
        if (!isOpen) el.classList.add('tooltip-open');
    });
});
document.addEventListener('click', function() {
    document.querySelectorAll('.stock-status.tooltip-open').forEach(function(el) { el.classList.remove('tooltip-open'); });
});

/* ---- Share button ---- */
var shareToggle = document.getElementById('share-toggle');
var shareDropdown = document.getElementById('share-dropdown');
var shareCopy = document.getElementById('share-copy');

if (shareToggle && shareDropdown) {
    shareToggle.addEventListener('click', function(e) {
        e.stopPropagation();
        if (navigator.share) {
            navigator.share({ title: document.title, url: window.location.href });
        } else {
            var open = shareDropdown.hidden;
            shareDropdown.hidden = !open;
            shareToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        }
    });

    document.addEventListener('click', function() {
        shareDropdown.hidden = true;
        shareToggle.setAttribute('aria-expanded', 'false');
    });

    shareDropdown.addEventListener('click', function(e) {
        e.stopPropagation();
    });
}

if (shareCopy) {
    shareCopy.addEventListener('click', function() {
        navigator.clipboard.writeText(window.location.href).then(function() {
            shareCopy.textContent = 'Copied!';
            setTimeout(function() {
                shareCopy.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="9" y="9" width="13" height="13" rx="2" ry="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg> Copy link';
            }, 2000);
        });
    });
}

